import { Component, Input, OnInit } from '@angular/core';
import { RmsColors } from '../../../constants/rms-colors';

/**
 * Component class for bubble timeline
 */
@Component({
    selector: 'rms-bubble-icon',
    templateUrl: './bubble-icon.component.html',
    styleUrls: ['./bubble-icon.component.scss'],
    standalone: false
})
export class BubbleIconComponent implements OnInit {

  @Input() icon: string = null;
  @Input() color: string = null;

  constructor() {
  }

  ngOnInit() {
  }

  public getIconPath(): string {
    return 'assets/icons/' + this.icon + '-icon.svg';
  }

  public getBubbleColor(): string {
    if (this.color !== null) {
      return this.color;
    }
    if (this.icon === 'check') {
      return RmsColors.RMS_CRM_DETAILS_COLOR;
    } else if (this.icon === 'cancel') {
      return RmsColors.RMS_CRM_WARNING;
    } else if (this.icon === 'circle') {
      return  RmsColors.RMS_CRM_DETAILS_COLOR;
    } else {
      return RmsColors.RMS_GRAY_DETAIL;
    }
  }
}
